import { useState } from 'react';
import { subscribeNewsletter } from '@/lib/api';
import { toast } from 'sonner';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await subscribeNewsletter(email);
      toast.success('Successfully subscribed!');
      setEmail('');
    } catch (error) {
      toast.error('Failed to subscribe. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#111] border border-[#222] p-6" data-testid="newsletter-section">
      <h3 className="text-xl font-bold text-white">Stay Updated</h3>
      <p className="mt-2 text-gray-500 text-sm">
        Get the latest Cincinnati news in your inbox.
      </p>
      <form onSubmit={handleSubmit} className="mt-4 flex gap-0">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 px-4 py-3 bg-black border border-[#222] border-r-0 text-white focus:outline-none focus:border-yellow-500"
          required
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-3 bg-yellow-500 text-white font-medium hover:bg-yellow-600 transition-colors disabled:opacity-50"
          data-testid="newsletter-subscribe-btn"
        >
          {loading ? '...' : 'Join'}
        </button>
      </form>
    </section>
  );
};

export default Newsletter;
